import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import { message } from "antd";
import { votingDeleted, votingDeleting } from "../actions/editing";
import uri from "../../constants/uri";
import { getAllVoting } from "./get-voting";

const deleteVoting = (id) => async (dispatch) => {
	try {
		dispatch(votingDeleting());
		await client.delete(`${uri}/${id}`, {
			headers: authHeader(),
		});
		dispatch(getAllVoting());
		dispatch(votingDeleted());
	} catch (e) {
		console.error(e);
		message.error("Не получилось удалить опрос");
	}
};

export default deleteVoting;
